import React from "react";
import { Card, Form, Button, Divider, message, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import NHFetch from '../../../utils/NHFetch';
import NHInputRender from '../../common/NHInputPicker/render';
import { getLoginUser } from "../../../utils/NHCore";
import { hasAuth } from "../../../utils/NHCore";
import { NHModal, NHConfirm } from '../../common/NHModal';
import styles from '../index.css';

const basicUrl = '/yxxc/';

class Common extends React.Component {
    constructor() {
        super()
        this.state = {
            hjblztData: {}, //环节办理状态信息
            hjywxData: [], //环节业务项信息
            editable: true, //是否可编辑
            loading: false, //按钮转圈等待
            dmkmcList:{}
        };
        
    }

    componentWillReceiveProps(nextProps) {
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt == '1' ? false : true;
                this.setState({ hjblztData: hjblztData, editable: editable });
            } else {
                this.setState({ hjblztData: hjblztData, editable: true });
            }
        }
    }

    //确认办理
    handleSubmit = () => {

        const { xsid } = this.props.studentData;

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        const form = this.props.form;

        //校验
        form.validateFields((err, formData) => {

            if (err) {
                return;
            }

            const { pkid, hjdm } = this.state.hjblztData;
            const { xsid } = this.props.studentData;
            let userId = getLoginUser() ? getLoginUser().userId : '';
            let params = { xsid: xsid, lchjid: pkid, formData: formData, yhbh: userId, hjdm: hjdm };
            this.setState({ loading: true });
            NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理成功！');
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('submit');
                            }
                        } else if (res.data === 2) {
                            // 武汉铁路
                            message.warn("学生未缴费");
                        } else if (res.data === 3) {
                            // 武汉铁路
                            message.warn("缴费数据同步成功，该生未达到系统设置的最低缴费金额，无法自动办理缴费环节!");
                        } else if (res.data === 4) {
                            // 武汉铁路
                            message.warn("同步学生缴费信息失败");
                        } else {
                            message.error('环节办理失败，请重试！');
                        }
                        this.setState({ loading: false });
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })

        });
    }

    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.props.studentData;

        let params = { xsid: xsid, lchjid: pkid };
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                        } else {
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");

    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

    render() {
        const { form, hjywxData, hjblztData, lchjData = {}, hasLast, hasNext } = this.props;
        const { editable, loading } = this.state;
        const { sfdybdd = '0' } = lchjData; //是否打印报到单
        let formItems = [];
        let formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        if (hjywxData && hjywxData.length > 0) {

            for (let key in hjywxData) {
                let hjywx = hjywxData[key];
                let kjcsjson = JSON.parse(hjywx.kjcs);
                let ywxz = hjywx.ywxz;
                let zdbz = hjywx.zdbz;
                let formItem = "";
                if (editable) {
                    formItem = (
                        <NHInputRender id={hjywx.pkid}
                            label={hjywx.zdmc}
                            defaultValue={hjywx.mrz}
                            value={ywxz}
                            required={hjywx.sfbt == '1' ? true : false}
                            form={form}
                            feature={hjywx.kjcs}
                            formItemLayout={formItemLayout} />
                    );
                } else {
                    if (kjcsjson.type === "select") {
                        if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                            this.getDmkMc(kjcsjson.dataTag, zdbz);
                        }
                        let list = this.state.dmkmcList[zdbz];
                        list && list.map(item => {
                            if (item.VALUE === ywxz) {
                                ywxz = item.LABEL;
                            }
                        })
                    }else 
                    if (kjcsjson.type === "switch") {
                        ywxz = (ywxz === "true") ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                    } else if (kjcsjson.type === "radio") {
                        kjcsjson.options && kjcsjson.options.map((item, key) => {
                            if (item.value === ywxz) {
                                ywxz = item.label;
                            }
                        })
                    }


                    formItem = 
                    <Row className={styles.personal}>
                        <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                            <div><span style={{marginLeft:'30px'}}>{hjywx.zdmc}</span>：<span >{ywxz}</span></div>
                        </Col>
                    </Row>
                    
                }
                formItems.push(formItem);
            }

        } else {
            let formItem = (<span>暂无需要填写的业务项信息</span>);
            formItems.push(formItem);
        }

        return (
            <div>
                <Card type="inner" title={hjblztData && hjblztData.hjmc ? `${hjblztData.hjmc}业务信息` : '业务信息'}>
                    <Form>
                        {formItems}
                    </Form>
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable ?
                        (hasAuth('zhxg_yxgl_yxxc:submit') ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> : null)
                        : (hasAuth('zhxg_yxgl_yxxc:cancel') ? <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button> : null)
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                        : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                        : null
                }
            </div>
        )
    }
}

const common = Form.create()(Common);

Common.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态数据
    hjywxData: PropTypes.array, //环节业务项数据
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一个环节
    hasNext: PropTypes.bool, //是否有下一个环节
    onLast: PropTypes.func,//上一步操作回调
    onNext: PropTypes.func, //下一步操作回调
    onFinish: PropTypes.func, //环节办理完成回调
    onPrint: PropTypes.func, //打印报到单
}
export default common


// WEBPACK FOOTER //
// ./components/yxxc/steps/common.js